<template>
<div class="guide-common-content">
    <div class="g-common-frames">
        <div class="dzhkfs-frames subjectActivity-frames">
            <!-- <div class="dzhkfs-bg"></div> -->
            <div class="dzhkfs-frames-content">
                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/thyc-xcb-icon-1@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>途虎养车大礼包</h3>
                        <p>鑫驰白金卡激活即送</p>
                        <p>
                            <span>5400元途虎养车大礼包</span>活动
                        </p>
                    </div>
                </div>

                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/jy85-xcb-icon-2@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>活动时间</h3>
                        <p>2020年6月1日-2020年12月31日</p>
                    </div>
                </div>

                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/jy85-xcb-icon-3@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>活动对象</h3>
                        <p>鑫驰白金卡持卡人</p>
                    </div>
                </div>

                <div class="subjectActivity-frames-item">
                    <div class="subjectActivity-frames-item-block">
                        <div class="subjectActivity-item-left">
                            <img src="@/assets/images/thyc-xcb-icon-2@2x.png" alt />
                        </div>
                        <div class="subjectActivity-item-right">
                            <h3>活动内容</h3>
                            <p>
                                <span>激活即送5400元途虎养车大礼包</span>
                            </p>
                            <p>活动期间，首次成功激活本行鑫驰白金卡的持卡人，可获5400元途虎大礼包。</p>
                        </div>
                    </div>
                    <div class="subjectActivity-item-column">
                        <img src="@/assets/images/thyc-xcb-table.png" alt />
                    </div>
                    <div class="subjectActivity-item-column">
                        <div class="subjectActivity-title">小贴士</div>
                        <div class="subjectActivity-details">
                            <p class="small">礼包使用规则和有效期以“途虎养车APP”载明为准。优惠券可通过在“途虎养车APP”中用券下单预约，持卡人需要通过用券在线上预约的方式，到上海地区内部分途虎合作门店（以“途虎养车APP”显示为准）享受服务。</p>
                        </div>
                    </div>
                </div>

                <div class="subjectActivity-frames-item">
                    <h3 class="subjectActivity-title">活动细则</h3>

                    <div class="subjectActivity-details">
                        <p>1、本次活动对象为本行鑫驰白金卡持卡人，鑫驰白金卡（车牌分期）不纳入本次活动范围。</p>
                        <p>2、持卡人成功激活本行鑫驰白金卡后30个工作日内，持卡人可获得“途虎养车大礼包”，持卡人仅需通过鑫驰白金卡预留手机号登录“途虎养车APP”—我的—优惠券入口，即可查看，具体下发时间以“途虎养车APP”显示为准。优惠券不支持拼团使用；优惠券有效期及使用规则以“途虎养车APP”载明为准。</p>
                        <div class="other-content" v-show="isShow3">
                            <p>3、优惠券使用规则：</p>
                            <p class="font-indent">a)适用车型：7座（含）以下家用非营运轿车。</p>
                            <p class="font-indent">b)不适用车型：营运性质车辆，包括但不限于货车、出租车、单位用车、租赁用车等。</p>
                            <p class="font-indent">c)优惠券仅限在“途虎养车APP”使用，并仅限在途虎合作门店完成施工；不得兑换其他产品或服务，不可兑换现金。</p>
                            <p class="font-indent">d)优惠券使用有效期以券面记载为准，过期作废。</p>
                            <p>4、持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                            <p>5、如发现持卡人参与活动过程中存在任何利用系统漏洞或规则漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、违背活动公平原则、违背诚实信用原则、扰乱正常活动秩序等行为的，包括但不限于使用外挂获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消持卡人参加本次活动及获得本活动奖励的资格，并有权取消或收回其因参加本次活动所获的奖励。同时，上海农商银行保留追求其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回持卡人参加本活动所获的回馈和奖励权利。</p>
                            <p>6、在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号、信用卡APP或各分支网点等）公告后生效。</p>
                            <p>7、其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机关及银行卡组织相关规定约束。</p>
                            <p>8、活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                        </div>
                        <div class="subjectActivity-item-right-bottom">
                            <a href="javascript:;" class="more-rule subject-tjx-rule common-subjectActivity-more" @click="e=>this.changeOther('isShow3')" v-show="!isShow3">展开详情</a>
                            <div class="collect-wrap" v-show="isShow3">
                                <div class="collect-btn" @click="e=>this.changeOther('isShow3')">
                                    <i class="guide-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex'
export default {
    data() {
        return {
            isShow1: false,
            isShow2: false,
            isShow3: false,
        };
    },
    computed: {
        ...mapState(['mirror'])
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        changeOther(name) {
            this[name] = !this[name];
        },
        changeTestLink(type) {
            this.$test(`${type}${this.mirrorStatus ? this.mirrorStatus+1 : ""} a-register-2`);
            this.$router_push(this.mirror.current_link)
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
